import { formatMonthly } from '@/Shared/proPlanState'

// Rows for the "Starting at" tier table (86bcd9hg3, decision 23): one row per Pro tier,
// "Units Managed | Basic | Pro". Basic is free at every size; Pro is shown as its monthly
// equivalent and labelled "billed annually" by the table. Pure so it can be unit tested;
// `proTiers` is the shared tier list ({ min, max, monthly_equivalent, ... }), lowest first.
export function buildStartingAtRows(proTiers) {
    return (proTiers ?? []).map((tier) => ({
        units: tier.max === null || tier.max === undefined
            ? `${Math.max(tier.min, 1)}+ Units`
            : `${Math.max(tier.min, 1)}-${tier.max}`,
        basic: 'Free',
        pro: `${formatMonthly(tier.monthly_equivalent)}/mo`,
    }))
}
